import React, { useState } from 'react';
import { useBatteryStore } from '../store/batteryStore';
import { 
  PackViewer3D, 
  ConfigPanel, 
  ResultsTable, 
  TabPanels,
  ElectricalRouting,
  ViewportControls,
  DraftManager,
  EmbedCodeGenerator
} from '../components/BatteryBuilder';
import { Button } from '../components/ui/button';
import { Separator } from '../components/ui/separator';
import { Battery, Zap, Settings, Code } from 'lucide-react';

export default function BatteryBuilderPage() {
  const { viewMode, results, generationTime, selectedResult } = useBatteryStore();
  const [showEmbedModal, setShowEmbedModal] = useState(false);
  
  return (
    <div className="min-h-screen bg-zinc-950 flex flex-col" data-testid="battery-builder-page">
      {/* Header */}
      <header className="h-14 border-b border-zinc-800 flex items-center justify-between px-4 bg-zinc-900/50">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 text-cyan-400">
            <Battery className="w-6 h-6" />
            <span className="font-heading text-xl font-bold tracking-wider">
              BATTERY PACK BUILDER
            </span>
          </div>
          <Separator orientation="vertical" className="h-6 bg-zinc-700" />
          <span className="text-xs text-zinc-500 font-mono">v1.0</span>
        </div>
        
        <div className="flex items-center gap-4">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setShowEmbedModal(true)}
            className="gap-2 border-cyan-800 text-cyan-400 hover:bg-cyan-950"
            data-testid="embed-btn"
          >
            <Code className="w-4 h-4" />
            Embed
          </Button>
          
          <DraftManager />
          
          {results.length > 0 && (
            <div className="text-xs font-mono text-zinc-500">
              <span className="text-cyan-400">{results.length}</span> configs •{' '}
              <span className="text-cyan-400">{generationTime.toFixed(1)}ms</span>
            </div>
          )}
        </div>
      </header>
      
      {/* Main Content */}
      <div className="flex-1 flex overflow-hidden">
        {/* Left Side - 3D Viewport / Routing */}
        <div className="flex-1 relative">
          {viewMode === '3d' ? (
            <PackViewer3D />
          ) : (
            <div className="w-full h-full bg-zinc-900/50 rounded-lg overflow-hidden">
              <ElectricalRouting />
            </div>
          )}
          <ViewportControls />
        </div>
        
        {/* Right Side - Config & Results */}
        <div className="w-96 border-l border-zinc-800 flex flex-col">
          {/* Config Panel */}
          <div className="h-[55%] overflow-hidden">
            <ConfigPanel />
          </div>
          
          {/* Results Table */}
          <div className="flex-1 border-t border-zinc-800 overflow-hidden">
            <ResultsTable />
          </div>
        </div>
      </div>
      
      {/* Bottom Panel - Tabs */}
      <div className="h-72 border-t border-zinc-800">
        <TabPanels />
      </div>
      
      {/* Embed Code Modal */}
      {showEmbedModal && (
        <EmbedCodeGenerator onClose={() => setShowEmbedModal(false)} />
      )}
    </div>
  );
}
